const REQUEST_MODAL_PARAM = '_modal';

/**
 * Check if the current page requests a modal to be opened on load.
 *
 * For example, when a session has expired when opening a modal link, the user
 * is redirected to the login screen. After logging in, they get redirected to
 * the actual modal URL itself. The backend can detect that with
 * `#turbo_frame_request?` and redirect to the main page instead but request the
 * correct modal to open via the `?modal=` parameter when the page is loaded.
 *
 * If the URL or path in that parameter matches the given modal target URL or
 * `#modal-id`, `true` will be returned and the parameter will be stripped from
 * the current window URL.
 *
 * Calling it again will therefore not return `true`, which protects from the
 * modal from being opened twice too, if another button links the same modal
 * address.
 *
 * @param {String} url URL, path, or ID of the modal to check
 */
export function isModalRequested(url) {
  if (!url) return false;

  const current = new URL(window.location.href);
  if (!current.searchParams.has(REQUEST_MODAL_PARAM)) {
    return false;
  }

  const requestedValue = current.searchParams.get(REQUEST_MODAL_PARAM);

  const match = (() => {
    if (!(url instanceof URL) && url[0] == '#') {
      return requestedValue === url.substring(1);
    } else {
      const modalURL = new URL(url, window.location.href);
      const requestedURL = new URL(requestedValue, current);
      return modalURL.toString() === requestedURL.toString();
    }
  })();

  if (match) {
    current.searchParams.delete(REQUEST_MODAL_PARAM);
    window.history.replaceState({}, document.title, current);
  }

  return match;
}
